<template>
    <div class="input-increment">
        <div class="d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center align-items-center" :class="counter === this.min ? 'disabled' : ''" @click="decr">
                <span class="mdi mdi-arrow-left"></span>
            </div>
            <div>
                <b>{{counter}}</b>
            </div>
            <div class="d-flex justify-content-center align-items-center" :class="disabled ? 'disabled' : ''" @click="incr">
                <span class="mdi mdi-arrow-right"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'InputIncrement',
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      counter: this.value
    }
  },
  methods: {
    decr (event) {
      event.preventDefault()
      if (this.counter - 1 >= this.min) this.counter--
      this.$emit('change', this.counter)
    },
    incr (event) {
      event.preventDefault()
      if (this.disabled) return
      this.counter++
      this.$emit('change', this.counter)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/InputIncrement.vue